import styled from "@emotion/styled";
import {
  ArrowRight,
  Button,
  Identity,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

import { MemoizedPageHeader as PageHeader } from "@/components/shared/PageHeader/component";

export const StyledContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const StyledButtonHeaderContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});

export const StyledPageHeader = styled(PageHeader)({
  justifyContent: "space-between",
  padding: "0 40px 20px 40px",
});

export const StyledNotificationsButton = styled(Button)({
  gap: "2px",
});

export const StyledSectionContainerDiv = styled("div")({
  paddingLeft: "34px",
});

export const StyledTitleText = styled(Text)({
  padding: "24px 0 24px 34px",
});

export const StyledCardContainerDiv = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: "8px",
  rowGap: "8px",
  padding: "0 68px 34px 34px",
});

export const StyledTextContainerDiv = styled("div")({
  paddingRight: "24px",
});

export const StyledCard = styled("div")(({ theme }) => ({
  padding: "24px",
  backgroundColor: theme.palette.grey[50],
  borderRadius: "8px",
}));

export const StyledRoundedTopRightCardDiv = styled("div")(({ theme }) => ({
  padding: "24px",
  backgroundColor: theme.palette.grey[50],
  borderRadius: "8px 40px 8px 8px",
}));

export const StyledCardTitleText = styled(Text)(({ theme }) => ({
  fontFamily: '"Nunito", sans-serif',
  lineHeight: 1,
  color: theme.palette.grey[500],
  padding: "0 0 16px 0",
}));

export const StyledCardContentText = styled(Text)({
  padding: "16px 0 0 0",
  fontSize: "14px",
});

export const StyledIdentity = styled(Identity)({
  padding: "16px 0 0 0",
  ".MuiAvatar-circular": {
    backgroundColor: "#50e3c2",
    "*": {
      color: "white",
    },
  },
  ".MuiTypography-text1": {
    color: "#86959b",
  },
});

export const StyledAddressContainerDiv = styled("div")({
  display: "flex",
  padding: "16px 0 0 0",
  ".MuiTypography-text1": {
    color: "#86959b",
  },
});

export const StyledArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.white,
}));
